import {styled} from '@mui/material'
import {React} from 'common'
import PeriodSelect from 'components/Control/PeriodSelect'
import {useI18n} from 'store/Store'
import PageTitle from 'components/Display/PageTitle'
import {useDeviceDetect} from 'services/hooks'

const DashboardHeader = ({user, setPeriod}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    return (
        <Container>
            {!isMobile && (
                <PageTitle
                    title={i18n.t('dashboard.helloUser', {
                        firstName: ` ${user?.firstname}` || '',
                    })}
                    subtitle={i18n.t('dashboard.greeting')}
                />
            )}

            <PeriodSelect onSelectPeriod={setPeriod} />
        </Container>
    )
}

export default DashboardHeader

const Container = styled('div')`
    display: flex;
    justify-content: space-between;
    width: 100%;
`
